import { createContext, useState } from "react";

// If the user chooses "Returning a gift" we fill this data in to store their data.
const FlowStepContext = createContext({
  flowStep: undefined,
  setFlowStep: (flowStep: any) => {},
  submitting: false,
  setSubmitting: (submitting: boolean) => {},
});

const FlowStepContextProvider = ({ children }) => {
  const [flowStep, setFlowStep] = useState(undefined);
  const [submitting, setSubmitting] = useState(false);

  return (
    <FlowStepContext.Provider
      value={{
        flowStep,
        setFlowStep,
        submitting,
        setSubmitting,
      }}
    >
      {children}
    </FlowStepContext.Provider>
  );
};

export { FlowStepContext, FlowStepContextProvider };
